import React, {useRef, useEffect, useCallback} from 'react'
import { gsap, Back } from '../gsap/gsap-core'
import { CSSPlugin } from '../gsap/CSSPlugin';

gsap.registerPlugin(CSSPlugin);

const Headline = () => {
  let headlineRef = useRef('');
  
  const init = useCallback(() => {
   gsap.from(headlineRef.current, {
          css: {
            scaleX: 0,
            transformOrigin: "50% 50%",
            opacity: 0,
            perspective: 400,
          },
          duration: 1,
          ease: Back.easeInOut
        },
      "-=.2"
      )
    },[])
  

  useEffect(() => {
    init();
    return (() => init);
  },[init])

  return (
    <h1 
      ref={headlineRef}
      className="snippets-wrapper__title">Snippets</h1>
  )
}

export default Headline;
